import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { RequestTypes } from '../requestTypes'
import { permitsKeys } from '../permitsKeys'
import {
  IParticipantListItem,
  ParticipantListItem,
} from '@core/entities/participant/ParticipantListItem'

const participantsTransform = (data: IParticipantListItem[]) =>
  data.map(ParticipantListItem.new)

export const useGetPermitRecentParticipants = (
  payload: RequestTypes['getPermitParticipants'],
  options?: UseQueryOptions<ParticipantListItem[], string>,
) => {
  return useQuery({
    cacheTime: 1000 * 60 * 60 * 24 * 31 * 6, // 6 months
    select: participantsTransform,
    ...permitsKeys.getRecentParticipants(payload),
    ...options,
  })
}
